import { Button, Collapse, Row, Col, Table, Tag } from "antd";
import { DownloadOutlined } from "@ant-design/icons/lib/icons";
import useRequest from "../../Hooks/useRequest";
import Filters from "./Filters";
import {
  suggestedProductReport,
  suggestedProductReportExport,
} from "../../Service/report";
import { downloadFile } from "../../Service";
import usePagination from "../../Hooks/usePagination";
import { notify } from "../../utils/notify";
import { formatDate } from "../../utils/date"; 

const { Panel } = Collapse;
const SuggestedProductReportTable = () => {
  const [Attributes, setAttributes] = usePagination({
    Id: undefined,
    Message: "",
  });
  const {
    data = {},
    status,
    message,
    update,
  } = useRequest(suggestedProductReport, [Attributes]);
  const Columns = [
    {
      key: "id",
      title: "Id",
      dataIndex: "id",
      width: 70,
    },
    {
      key: "email",
      title: "Email",
      dataIndex: "email",
      width: 100,
    },
    {
      key: "message",
      title: "Mesaj",
      dataIndex: "message",
      width: 200,
    },
    {
      key: "isActive",
      title: "Durum",
      dataIndex: "isActive",
      render: (isActive) => (
        <Tag color={isActive ? "geekblue" : "volcano"}>
          {isActive ? "Aktif" : "Pasif"}
        </Tag>
      ),
      width: 50,
    },
    {
      key: "isDeleted",
      title: "Silindi",
      dataIndex: "isDeleted",
      render: (isDeleted) => isDeleted && <Tag color={"volcano"}>Silindi</Tag>,
      width: 50,
    },
    {
      key: "createdAt",
      title: "Oluşturulma Tarihi",
      dataIndex: "createdAt",
      render: (date) => formatDate(date),
    },
    {
      key: "updatedAt",
      title: "Güncellenme Tarihi",
      dataIndex: "updatedAt",
      render: (date) => formatDate(date),
    },
    // {
    //   title: "Detay",
    //   dataIndex: "",
    //   fixed: "right",
    //   key: "x",
    //   render: (_, Record) => (
    //     <NavLink to={`/Customer/${Record.id}`}>
    //       <Button type="primary">Detay</Button>
    //     </NavLink>
    //   ),
    // },
  ];

  const paginationOptions = {
    showSizeChanger: true,
    showQuickJumper: true,
    onShowSizeChange: (_, pageSize) => {
      setAttributes({ Size: pageSize });
    },
    onChange: (page) => {
      setAttributes({ Index: page });
    },
    pageSizeOptions: Attributes.INDEX_PAGE_SIZE_OPTIONS,
    total: data.totalCount,
  };
  const pagination = {
    ...paginationOptions,
    total: data.totalCount,
    current: data.index,
    pageSize: data.size,
  };
  const onFilter = (values) => {
    setAttributes({
      ...values,
    });
  };

  const _demandedExport = () => {
    notify("info");
    suggestedProductReportExport()
      .then((res) => {
        downloadFile(res);
        notify("success");
      })
      .catch(() => {
        notify("error");
      });
  };

  return (
    <>
      {/* <Collapse>
        <Panel header="Filtreler">
          <Filters onSubmit={onFilter} />
        </Panel>
      </Collapse> */}
      <Row>
        <Col
          style={{ padding: "24px 24px 24px 0", right: 0, marginLeft: "auto" }}
        >
          <Button
            type="primary"
            shape="round"
            icon={<DownloadOutlined />}
            onClick={_demandedExport}
          >
            Önerilen Ürünler Raporu Export
          </Button>
        </Col>
      </Row>
      <Table
        loading={status === "pending"}
        dataSource={status === "success" ? data.data : []}
        columns={Columns}
        pagination={pagination}
        rowKey={"id"}
      />
    </>
  );
};

export default SuggestedProductReportTable;
